export default{

	"name": "Российская Федерация",
	"sub_regions":
		[ 
			{
				"name": "Центральный ФО",
				"sub_regions": 
				[
					"Белгородская область",
					"Владимирская область",
					"Воронежская область",
					"Ивановская область",
					"Калужская область",
					"Костромская область",
					"Курская область",
					"Липецкая область",
					"город  Москва",
					"Московская область",
					"Орловская область",
					"Рязанская область",
					"Смоленская область",
					"Тамбовская область",
					"Тверская область",
					"Тульская область",
					"Ярославская область"
				]
			}, 
			{
				"name": "Северо-Западный ФО",
				"sub_regions": 
				[
					"Архангельская область",
					"Вологодская область",
					"Калининградская область",
					"республика Карелия",
					"республика Коми",
					"Ленинградская область",
					"Мурманская область",
					"Ненецкий АО",
					"Новгородская область",
					"Псковская область",
					"город Санкт-Петербург",
				]
			},
			{
				"name": "Южный ФО",
				"sub_regions": 
				[
					"республика Адыгея",
					"Астраханская область",
					"Волгоградская область",
					"республика Калмыкия",
					"Краснодарский край",
					"республика Крым",
					"Ростовская область",
					"город Севастополь"
				]
			},
			{
				"name": "Северо-Кавказский ФО",
				"sub_regions": 
				[
					"республика Дагестан",
					"республика Ингушетия",
					"Кабардино-Балкарская республика",
					"Карачаево-Черкесская республика",
					"республика Северная Осетия-Алания",
					"Ставропольский край",
					"Чеченская республика"
				]
			},
			{
				"name": "Приволжский ФО",
				"sub_regions": 
				[
					"республика Башкортостан",
					"Кировская область",
					"республика Марий-Эл",
					"республика Мордовия",
					"Нижегородская область",
					"Оренбургская область",
					"Пензенская область",
					"Пермский край",
					"Пермская область",
					"Коми-Пермяцкий АО",
					"Саратовская область",
					"республика Татарстан",
					"Удмуртская республика",
					"Чувашская республика",
				]
			},
			{
				"name": "Уральский ФО",
				"sub_regions": 
				[
					"Курганская область",
					"Свердловская область",
					"Тюменская область",
					"Ханты-Мансийский АО - Югра",
					"Челябинская область",
					"Эвенкийский АО",
					"Ямало-Ненецкий АО"
				]
			},
			{
				"name": "Сибирский ФО",
				"sub_regions": 
				[
					"Красноярский край",
					"республика Алтай",
					"Алтайский край",
					"Иркутская область",
					"Усть-Ордынский Бурятский АО",
					"Кемеровская область",
					"Новосибирская область",
					"Омская область",
					"Таймырский  АО",
					"Томская область",
					"республика Тыва",
					"республика Хакасия",
				]
			},
			{
				"name": "Дальневосточный ФО",
				"sub_regions": 
				[
					"Амурская область",
					"республика Бурятия",
					"Еврейская AO",
					"Еврейская автономная область",
					"Забайкальский край",
					"Читинская область",
					"Агинский бурятский AO",
					"Камчатский край",
					"Камчатская область",
					"Корякский АО",
					"Магаданская область",
					"Приморский край",
					"республика Саха (Якутия)",
					"Сахалинская область",
					"Хабаровский край",
					"Чукотский АО",
				]
			},
			{
				"name": "Крымский ФО",
				"sub_regions": 
				[
					"республика Крым",
					"город Севастополь"
				]
			},
		]
}